/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_CreateInputs */



/**
* | output |
* | --- |
* | "Create template" |
*
* @param {Settings_Template_CreateInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_create = /** @type {((inputs?: Settings_Template_CreateInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_CreateInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Template aanmaken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer le modèle")
	return /** @type {LocalizedString} */ ("Create template")
});